const types = {
    SET_TRANSACTION_REPORT: '[REPLENISHMENT REPORT] SET TRANSACTION REPORT',
}

export {
    types
}